import {
  GUEST,
  LOGGED_IN_B2B,
  LOGGED_IN_IA,
  LOGGED_IN_CSP
} from 'constants/analyticsConstants';
import { UserRoles, UserTypes } from 'services/user/types';
import { Availability, SourcingDetail } from 'services/order/types';

export const getCheckoutType = (userType: string, isCSPCustomer: boolean, isInstantAccessUser?: boolean, userRoles?: string[]) => {
  const isB2BUser = userRoles?.includes(UserRoles.ADMIN) ||
  userRoles?.includes(UserRoles.APPROVER) || userRoles?.includes(UserRoles.SUBMITTER);
  const isIAUser = !isCSPCustomer && isInstantAccessUser;
  if (userType === UserTypes.REGISTERED || userType === UserTypes.ADMIN) {
    if(isCSPCustomer && isB2BUser)
      return LOGGED_IN_B2B;
    else if(isCSPCustomer)
      return LOGGED_IN_CSP;
    else if(isIAUser)
    return LOGGED_IN_IA;
  }

  return GUEST;
};

type GetInventoryStatusResponse =
  | string
  | string[]
  | Availability
  | Availability[];
export const getInventoryStatus = (
  contactDealerKey: string,
  availability: Availability[],
  sourcingDetails: SourcingDetail[]
): GetInventoryStatusResponse => {
  const quantityAvailability = initializeQuantityAvailability();

  if (hasSourcingDetails(sourcingDetails)) {
    updateQuantityAvailability(quantityAvailability, sourcingDetails);
    updateContactDealerQuantity(
      contactDealerKey,
      quantityAvailability,
      availability
    );

    return formatInventoryStatus(quantityAvailability);
  }

  return formatAvailability(availability);
};

type QuantityAvailabilityMap = Map<
  string,
  { quantity: number; availabilityMessage: string }
>;

function initializeQuantityAvailability(): QuantityAvailabilityMap {
  return new Map([
    ['Instock', { quantity: 0, availabilityMessage: 'Instock' }],
    ['Dealer Network', { quantity: 0, availabilityMessage: 'Dealer Network' }],
    ['Cat DC', { quantity: 0, availabilityMessage: 'Cat DC' }],
    ['Contact Dealer', { quantity: 0, availabilityMessage: 'Contact Dealer' }]
  ]);
}

function hasSourcingDetails(sourcingDetails: SourcingDetail[]) {
  return sourcingDetails?.length > 0;
}

function updateQuantityAvailability(
  quantityAvailability: QuantityAvailabilityMap,
  sourcingDetails: SourcingDetail[]
) {
  const sourcingMap = new Map<number, number>();

  sourcingDetails.forEach((item) => {
    const sequenceIndex = Number(item.sequence);
    const totalQuantity = item.availStoreList.reduce(
      (acc, curr) => acc + Number(curr.quantityAvailable),
      0
    );

    sourcingMap.set(
      sequenceIndex,
      sourcingMap.get(sequenceIndex) + totalQuantity
    );
  });

  quantityAvailability.forEach((value, index) => {
    if (sourcingMap.has(Number(index))) {
      value.quantity = sourcingMap.get(Number(index));
    }
  });
}

function updateContactDealerQuantity(
  contactDealerKey: string,
  quantityAvailability: QuantityAvailabilityMap,
  availability: Availability[]
): void {
  if (Array.isArray(availability)) {
    const hasContactDealer = availability.find(
      (item: { availabilityMessage: string }) =>
        item.availabilityMessage === contactDealerKey
    );

    if (hasContactDealer) {
      quantityAvailability.get(contactDealerKey).quantity =
        +hasContactDealer.quantityAvailable;
    }
  }
}

function formatInventoryStatus(
  quantityAvailability: QuantityAvailabilityMap
): string {
  return Array.from(quantityAvailability.values())
    .map((item) => `${item.quantity}: ${item.availabilityMessage}`)
    .join(' | ');
}

function formatAvailability(availability: Availability[]) {
  if (Array.isArray(availability)) {
    return availability
      .map((node) => `${node.quantityAvailable}: ${node.availabilityMessage}`)
      .join(', ');
  }

  return availability;
}
